import SvgIcon from '@elementor/ui/SvgIcon';
import PropTypes from 'prop-types';

const ArrowRightIcon = ({ size = 11 }, props) => {
	return (
		<SvgIcon
			width="11"
			height="9"
			fill="none"
			viewBox="0 0 11 9"
			sx={{ fontSize: size }}
			{...props}
		>
			<path
				fill="#000"
				fillOpacity=".54"
				fillRule="evenodd"
				d="M5.48.146a.5.5 0 0 1 .707 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.707-.708L8.626 5H.5a.5.5 0 0 1 0-1h8.126L5.48.854a.5.5 0 0 1 0-.708"
				clipRule="evenodd"
			/>
		</SvgIcon>
	);
};

ArrowRightIcon.propTypes = {
	size: PropTypes.number,
};

export default ArrowRightIcon;
